import { RequestMethod } from "@/shared/utils/RequestMethod";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = "https://restcountries.com/v3.1";

export const countriesApi = createApi({
  reducerPath: "countriesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),
  endpoints: (builder) => ({
    getAllCountries: builder.query({
      query: () => "/all?fields=name,region,capital,cca2,flags",
    }),
    countries: builder.query({
      query: () => ({
        url: "/all?fields=name,region,capital,cca2,flags",
        method: RequestMethod.GET,
        params: {
          fields: "name,flags,cca2",
        },
      }),
      transformResponse: (response: any) =>
        response.map((country: any) => ({
          id: country.name.common,
          name: country.name.common,
          flag: country.flags.png,
          isoCode: country.cca2,
        })),
    }),
  }),
});

export const { useGetAllCountriesQuery, useCountriesQuery } = countriesApi;
